<template>
  <div>
    <div :class="$style.commodityTopBtn">
      <div :class="$style.commodityTopLeftBtn">
        <template v-if="type === 'commodityManage'">
          <el-input v-model="filterData.commodityNo" placeholder="請輸入商品名稱或是商品貨號" :class="$style.commodityTopLeftBtn__input">
            <i slot="suffix" class="el-icon-search el-input__icon" @click="tryToFetchListFilter"> </i>
          </el-input>
        </template>
      </div>
      <div :class="$style.commodityTopRightBtn">
        <span>
          <el-button v-if="type === 'commodityManage'" class="is-round" @click="tagManage">
            <BaseIcon name="tag" />
            <span>標籤管理</span>
          </el-button>
        </span>
        <span>
          <el-button v-if="type === 'commodityManage'" type="primary" class="is-round" @click="addNewCommodity">
            <BaseIcon name="plus" />
            <span>新增商品</span>
          </el-button>
        </span>
        <span>
          <el-button v-if="type === 'inventoryManagement'" type="primary" class="is-round"
            @click="createDetail('purchase')">
            <BaseIcon name="plus" />
            <span>新增進貨單</span>
          </el-button>
        </span>
        <span>
          <el-button v-if="type === 'inventoryManagement'" type="primary" class="is-round"
            @click="createDetail('return')">
            <BaseIcon name="plus" />
            <span>新增廠商退貨單</span>
          </el-button>
        </span>
      </div>
    </div>
    <div>
      <BaseTableSearch v-if="searchTableShow" v-slot="{ fields }" hide-action :default-value="filterData"
        class="isForTab2" :class="$style.displaySearchTable" @reset="onFilterReset"
        @tryToFetchList="tryToFetchListFilter">
        <template v-if="templateRouter === 'tempCommodityManage'">
          <el-form-item prop="state">
            <el-select v-model="fields.haveInventory" placeholder="所有庫存" @change="tryToFetchListFilter">
              <el-option label="所有庫存" :value="``"></el-option>
              <el-option label="尚有庫存" :value="1"></el-option>
              <el-option label="無庫存" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="petCategoryId">
            <el-select v-model="fields.petCategoryId" :placeholder="`選擇${$t('reserve.CLIENT')}類別`"
              @change="tryToFetchListFilter">
              <el-option label="所有類別" value=""></el-option>
              <el-option v-for="option in leafOption" :key="option.id" :value="option.id"
                :label="option.categoryTitle"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="tag">
            <el-select v-model="fields.tag" :placeholder="`過濾標籤`" multiple @change="tryToFetchListFilter">
              <el-option v-for="item in tagList" :key="item.id" :value="item.id" :label="item.title">
              </el-option>
            </el-select>
          </el-form-item>
        </template>
        <template v-if="templateRouter === 'tempInventoryManagement'">
          <el-form-item prop="petCategoryId">
            <el-input v-model="filterData.inventoryNo" placeholder="請輸入單號" :class="$style.commodityTopLeftBtn__input">
              <i slot="suffix" class="el-icon-search el-input__icon" @click="tryToFetchListFilter"> </i>
            </el-input>
          </el-form-item>
          <el-form-item prop="petCategoryId">
            <el-select v-model="filterData.operatorType" :placeholder="`選擇${$t('reserve.CLIENT')}類別`"
              @change="tryToFetchListFilter">
              <el-option label="所有種類" value></el-option>
              <el-option label="進貨單-新增" value="add"></el-option>
              <el-option label="退貨單-減少" value="sub"></el-option>
              <el-option label="進貨單-調配" value="allocate"></el-option>
            </el-select>
          </el-form-item>
        </template>
      </BaseTableSearch>
      <div class="el-table-wrapper">
        <ElTableDraggable handle=".handle" @drag="startDraggable" @drop="endDraggable">
          <el-table ref="multipleTable" v-loading="tryingFetch" style="padding: 20px;"
            :default-sort="{ prop: 'created', order: 'descending' }" :data="tableData" element-loading-text="取得商品資訊中"
            :class="$style['table']" @row-click.once="goToDetail" @selection-change="handleSelectionChange">
            <!-- 商品管理 -->
            <template v-if="templateRouter === 'tempCommodityManage'">
              <el-table-column v-if="tableCheckboxShow" type="selection" width="100px"> </el-table-column>
              <el-table-column v-slot="{ row }" label="圖片" min-width="150">
                <el-image class="image image--square" :src="row.images.length > 0 ? row.image : ''" fit="cover">
                  <div slot="error">
                    <BaseIcon name="image" class="image--error" />
                  </div>
                </el-image>
              </el-table-column>
              <el-table-column v-slot="{ row }" label="商品名稱" prop="type" min-width="170">
                {{ row.title }}<br />
                {{ row.petCategoryTitle }}
              </el-table-column>
              <el-table-column v-slot="{ row }" label="商品貨號" prop="type" min-width="80">{{ row.no }} </el-table-column>
              <el-table-column v-slot="{ row }" label="庫存" prop="type" min-width="140">
                <span v-if="row.inventory < 1" style="color: #f25555">無庫存(0)</span>
                <span v-else style="color: #12C494">尚有庫存({{ row.inventory }})</span>
              </el-table-column>
              <el-table-column v-slot="{ row }" label="已售出" sortable prop="type" min-width="100">
                <span>{{ row.qty }}</span>
              </el-table-column>
              <el-table-column label="" min-width="120">
                <el-button type="text" class="handle" :class="$style.btnGripVertical">
                  <BaseIcon icon-style="far" name="fa-ellipsis-v" />
                </el-button>
              </el-table-column>
            </template>
            <!-- 庫存管理 -->
            <template v-if="templateRouter === 'tempInventoryManagement'">
              <el-table-column v-slot="{ row }" label="單號" prop="type" min-width="100">{{ row.no }}
              </el-table-column>
              <el-table-column v-slot="{ row }" label="建立日期" prop="type" min-width="150">
                <span v-if="row.createdAt">
                  {{ row.createdAt }}
                </span>
                <BaseIcon v-else icon-style="fal" name="fa-minus" />
              </el-table-column>
              <el-table-column v-slot="{ row }" label="種類" prop="type" min-width="80">
                <span v-if="row.operatorType === 'add'">進貨單-<span style="color: #12C494">新增</span></span>
                <span v-if="row.operatorType === 'sub'">退貨單-<span style="color: red">減少</span></span>
                <span v-if="row.operatorType === 'allocate'">進貨單-<span style="color: #12C494">調配</span></span>
              </el-table-column>
              <el-table-column v-slot="{ row }" label="操作人員" prop="type" min-width="140">
                <span>{{ row.createdBy }}</span>
              </el-table-column>
              <el-table-column v-slot="{ row }" label="查看明細" min-width="120">
                <el-button type="text" class="handle" :class="$style.btnGripVertical"
                  @click="toInventoryHistoryDetail(row)">
                  <BaseIcon icon-style="far" name="fa-ellipsis-v" />
                </el-button>
              </el-table-column>
            </template>
            <!-- 進退貨紀錄 -->
            <template v-if="false">
              <el-table-column v-if="tableCheckboxShow" type="selection" width="100px"> </el-table-column>
              <el-table-column v-slot="{ row }" type="expand" width="50">
                <template :slot-scope="row.expendData">
                  <div style="padding-left: 170px">
                    <div v-for="(data, index) in row.expendData" :key="index">
                      <div class="d-flex">
                        <div class="cell" style="width: 200px;">{{ data.info }}</div>
                        <div>
                          <div v-for="(d, i) in data.shop" :key="i" class="d-flex"
                            :class="{ 'mb-2': i + 1 < data.shop.length }">
                            <div class="cell" style="width: 222px;">{{ d.title }}</div>
                            <div class="cell" style="width: 195px;"
                              :class="{ 'text-success': d.after >= d.before, 'text-danger': d.before > d.after }">
                              {{ d.before }}
                              <BaseIcon icon-style="far" name="fa-arrow-right" />{{ d.after }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr v-if="index + 1 < row.expendData.length" class="my-3" style="border: 1px solid #f2f2f2" />
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column v-slot="{ row }" label="成立時間" prop="type" width="170">{{ row.created_at }}
              </el-table-column>
              <el-table-column v-slot="{ row }" label="" min-width="150">
                <el-image class="image image--square" :src="row.images.length > 0 ? row.image : ''" fit="cover">
                  <div slot="error">
                    <BaseIcon name="image" class="image--error" />
                  </div>
                </el-image>
              </el-table-column>
              <el-table-column v-slot="{ row }" label="商品" prop="type" min-width="170">{{ row.title }}<br />{{
                row.category }} </el-table-column>
              <el-table-column v-slot="{ row }" label="總存貨數量變動" prop="type" min-width="170">
                <p :class="{ 'text-success': row.after >= row.before, 'text-danger': row.before > row.after }">{{
                  row.before }}
                  <BaseIcon icon-style="far" name="fa-arrow-right" />{{ row.after }}
                </p>
              </el-table-column>
              <el-table-column v-slot="{ row }" label="操作人員" prop="type" min-width="170">
                {{ row.operator }}
              </el-table-column>
            </template>
          </el-table>
          <BasePagination ref="pagination" :class="$style.paginationStyle" show-size :current-page.sync="currentPage"
            :page-size.sync="pageSize" :select-mini-none="false" />
        </ElTableDraggable>
      </div>
    </div>
    <TagManage :dialog-visible.sync="tagManageVisible" />
  </div>
</template>

<script>
import lazyLoadComponent from '@router/lazyload-component'
import ElTableDraggable from 'element-ui-el-table-draggable'
import pageMixin from '@src/mixins/pagination'
import goodsMixin from '@/src/mixins/goodsMixin'
import { productTypeList, productTypeFilter, prepaidCapacityFilter, priceStatusFilter } from '@utils/filter-value-to-text'
import { formatDateRange } from '@utils/format-date'

export default {
  page: {
    title: '服務項目',
    meta: [{ name: 'description', content: 'Prepaid List' }],
  },
  components: {
    ElTableDraggable,
    TagManage: () => lazyLoadComponent(import('./TagManagment.vue')),
  },
  filters: {
    productTypeFilter,
    priceStatusFilter,
    prepaidCapacityFilter,
    formatDateRange,
  },
  mixins: [pageMixin, goodsMixin],
  props: {
    merchantProducts: {
      type: Array,
      required: true,
    },
    serviceCategory: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      default: '',
    },
    tableCheckboxShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableData: [], // 列表資料
      commodityName: '',
      selectedPrices: [],
      selectedPricesId: [],
      selectedDetail: {},
      filterData: {
        state: '',
        productId: '',
        type: '',
        petCategoryId: '',
        petSizeId: '',
        haveInventory: null, // 是否有庫存
        tagIds: [], // 標籤陣列
        operatorType: '',
        commodityNo: '', // 商品貨號搜尋
        inventoryNo: '', // 庫存貨號搜尋
      },
      productTypeList: Object.freeze(productTypeList),
      visibleDetail: false,
      previousPage: 1,
      previousTotal: 0,
      tryingFetchDetail: false,
      tryingFetch: false,
      pageSize: 10,
      currentPage: 1,
      action: '',
      changeToDelete: false,
      leafOption: [], // 子節點的值
      tagManageVisible: false, // 標籤管理開關窗
      tagList: [], // 標籤列表
    }
  },
  computed: {
    /**
     * @description 決定template長怎樣
     */
    templateRouter() {
      const typeRouter = {
        commodityManage: 'tempCommodityManage',
        inventoryManagement: 'tempInventoryManagement',
      }
      return typeRouter[this.type]
    },
    /**
     * @description 搜尋欄位是否要顯示
     */
    searchTableShow() {
      return ['commodityManage', 'inventoryManagement'].includes(this.type)
    },
  },
  watch: {
    tableData(nvl) {
      if (this.$refs.pagination) {
        this.$refs.pagination.updateTotal(nvl.length)
      }
    },
    pageSize: {
      handler(val) {
        if (this.currentPage !== 1) {
          this.currentPage = 1
        } else {
          this.tryToFetchList()
        }
      },
      immediate: false,
    },
    'filterData.petCategoryId': function (value) {
      this.filterData.petSizeId = ''
    },
    /**
     * @description 改變頁數時，會做的事情
     */
    currentPage(nvl) {
      this.tryToFetchList()
    },
  },
  created() {
    if (this.$route.params.createPrice) this.createDetail()
  },
  async mounted() {
    await this.fetchSelectLeaf()
    await this.tryToFetchList()
    await this.tryToFetchTagList()


  },
  methods: {
    /**
     * @description 關閉tab，並起開啟庫存細節
     */
    toInventoryHistoryDetail(row) {
      this.$emit('closeTabAndOpenInventoryDetail', row)
    },
    async tryToFetchTagList() {
      const res = await this.$store.dispatch('mixTag/mixTagSearch', {
        search: '',
        type: 'goods',
        paginate: 0,
      })
      this.tagList = res.items
    },
    /**
     * @description 尋找資料（include filterData
     */
    async tryToFetchListFilter() {
      if (this.currentPage !== 1) {
        this.currentPage = 1
      }
      this.pageQuery.limit = this.pageSize
      this.tryingFetch = true
      this.dealFilterData()
      // 商品管理的api搜尋
      if (this.type === 'commodityManage') {
        const { items, pagination } = await this.$store.dispatch(
          'product/fetchNormalServiceData',
          Object.assign({}, this.filterData, {
            paginate: 1,
            types: ['goods'],
            page: this.currentPage,
            limit: this.pageSize,
            search: this.filterData.commodityNo
          })
        )
        this.tableData = items
        this.updateTotal(pagination)
      }
      // 庫存管理
      if (this.type === 'inventoryManagement') {
        const { items, pagination } = await this.$store.dispatch(
          'product/fetchInventoryHistory',
          Object.assign({}, this.filterData, {
            paginate: 1,
            type: 'goods',
            page: this.currentPage,
            limit: this.pageSize,
            search: this.filterData.inventoryNo
          })
        )
        this.tableData = items
        this.updateTotal(pagination)
      }
      this.tryingFetch = false
    },
    /**
     * @description 增加filterData key值
     */
    dealFilterData() {
      this.$set(this.filterData, 'branchStoreId', this.filterData.productId)
      this.$set(this.filterData, 'tagIds', this.filterData.tag)
    },
    /**
     * @description 一開始進畫面，會打這支，做撈資料
     */
    async tryToFetchList() {
      try {
        this.pageQuery.limit = this.pageSize
        // 庫存管理打API
        if (this.type === 'inventoryManagement') {
          const { items } = await this.$store.dispatch(
            'product/fetchInventoryHistory',
            Object.assign({}, this.filterData, {
              paginate: 1,
              type: 'goods',
              page: this.currentPage,
              limit: this.pageSize
            })
          )
          this.tableData = items
        }
        // 商品管理打API
        if (this.type === 'commodityManage') {
          const { items, pagination } = await this.$store.dispatch(
            'product/fetchNormalServiceData',
            Object.assign({}, this.filterData, {
              paginate: 1,
              types: ['goods'],
              page: this.currentPage,
              limit: this.pageSize
            })
          )
          this.paginationTotal = pagination.total
          this.tableData = items
          this.updateTotal(pagination)
        }
      } catch (error) {
        console.error(error.message)
      } finally {
        this.tryingFetch = false
      }
    },
    /**
     * @description 更新 pagination
     */
    updateTotal(pagination) {
      this.$nextTick(() => {
        if (this.$refs.pagination) {
          this.$refs.pagination.updateTotal(pagination.total)
        }
      })
    },
    /**
     * @description 商品管理：點擊單列之後，看細節
     * @param {*} row
     */
    async goToDetail(row) {
      if (this.templateRouter === 'tempInventoryManagement') {
        return
      }
      const title = {
        commodityManage: '編輯商品資訊',
      }
      this.$store.commit('title/SET_TITLE', title[this.type])
      this.$router.push({
        name: 'view-goods',
        params: {
          type: this.type,
          thisServiceId: row.id,
          merchantProducts: this.merchantProducts,
          serviceCategory: this.serviceCategory,
        },
      })
      this.$emit('update-mode', 'edit')
    },
    /**
     * @description 到進貨單/退貨單頁面
     */
    createDetail(type) {
      this.$store.commit('inventory/TO_EMPTY_LIST') // 清空列表
      this.$store.commit('inventory/CLEAR_SELECT_SHIPPING_POINT')
      this.$emit('openPurchaseInformation', type)
    },
    /**
     * @description 標籤管理
     */
    tagManage() {
      this.tagManageVisible = true
    },

    /**
     * @description 新增商品func
     */
    addNewCommodity() {
      this.$store.commit('title/SET_TITLE', '新增商品')
      this.$router.push({
        name: 'add-goods',
        params: {
          type: this.type,
          merchantProducts: this.merchantProducts,
          serviceCategory: this.serviceCategory,
        },
      })
      this.$emit('update-mode', 'add')
    },
    /**
     * @description 重置filterData
     */
    onFilterReset() {
      this.$set(this.filterData, 'tag', [])
      this.$set(this.filterData, 'tagIds', [])
      this.$set(this.filterData, 'haveInventory', null)
      this.$set(this.filterData, 'petCategoryId', '')
      this.$set(this.filterData, 'commodityNo', '')
      this.$set(this.filterData, 'inventoryNo', '')
      this.tryToFetchList()
    },
    /**
     * @description 勾選到checkbox後，要做什麼事
     * @param {Object} selected 勾選到的物件
     */
    handleSelectionChange(selected) {
      this.selectedPricesId = selected.map(({ id }) => id)
    },
    /**
     * @description 拖拉「開始」瞬間
     */
    startDraggable() {
      this.cacheTableData = [...this.tableData]
    },
    /**
     * @description 拖拉「結束瞬間」
     * @param {*} targetObject：被移動的物件
     * @param {*} list：被移動過後的陣列
     */
    endDraggable({ targetObject, list }) {
      try {
        this.tryingFetch = true
        let action = 'before'
        let refId = ''
        const newTargetIndex = list.findIndex((item) => item.ordering === targetObject.ordering) // 新移到的位置
        if (newTargetIndex === 0) {
          action = 'before'
          refId = list[1].id
        }
        if (newTargetIndex + 1 === list.length) {
          action = 'after'
          refId = list[newTargetIndex - 1].id
        }
        if (newTargetIndex !== 0 && newTargetIndex + 1 !== list.length) {
          refId = list[newTargetIndex + 1].id
        }
        this.tryToOrderingPriceGroup(action, refId, list[newTargetIndex].id)
      } catch (error) {
        this.tryingFetch = false
        console.error(error.message)
      }
    },
    /**
     * @description 拖拉結束要打api
     * @param {*} ordering：點擊到的id
     * @param {*} indexDiff：兩者間距
     */
    async tryToOrderingPriceGroup(action, refId, id) {
      try {
        const urlRouter = {
          commodityManage: 'product/orderingServicePriceGroup',
        }

        await this.$store.dispatch(`${urlRouter[this.type]}`, {
          orderingData: {
            id,
            action,
            refId,
          },
        })
        this.tryToFetchList()
      } catch (error) {
        this.tryingFetch = false
        console.error(error.message)
      }
    },
    handleIconClick() { },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.table {
  @include layer-elevation(5);

  :global {
    tr.el-table__row.expanded {
      background-color: #f2f2f2;

      td:first-child {
        border-left: #c0975d 4px solid;
      }
    }
  }
}

.commodityTopRightBtn {
  display: flex;
  justify-content: flex-start;

  span {
    margin-left: 10px;
  }

  @include max-sm {
    :global {
      .el-button.is-add {
        width: 100% !important;
      }
    }
  }
}

.commodityTopLeftBtn {
  display: flex;
  justify-content: flex-start;

  &__select {
    width: 160px;

    :global {
      .el-input .el-input__inner {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
  }

  &__input {
    width: 435px;

    :global {
      .el-input__inner {
        border-radius: $border-radius;
      }
    }
  }
}

.commodityTopBtn {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.btnGripVertical {
  span svg {
    color: $color-primary;
  }
}

.displaySearchTable {
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  @include max-sm {
    flex-direction: column;
  }

  :global {
    .btn-box-inline {
      margin-top: 0 !important;
    }

    .el-form-item {
      &:first-child {
        @include max-md {
          margin-top: 1rem;
        }
      }

      margin-bottom: 5px;
    }
  }

  &>div {
    &:first-child {
      margin-right: 1rem;
    }

    @include max-sm {
      width: 100%;
    }
  }

  &__inventoryInput {
    :global {
      .el-input .el-input__inner {
        width: 450px;
      }
    }
  }
}

.paginationStyle {
  overflow-x: scroll;
}
</style>
